window.intlPhone = function (id) {
    const input = document.querySelector(id);

    if (input) {
        input.addEventListener('change', (event) => {
            const hiddenInput = document.getElementsByName(input.id);

            if (hiddenInput && hiddenInput[0]) {
                let fullNumber = input.value.split(/ (.*)/s);
                let countryData = iti.getSelectedCountryData()
                let dialCode = ('00' + countryData.dialCode).slice(-4);

                let formattedValue = '';
                if (fullNumber.length > 1) {
                    let prefixCode = fullNumber[0];
                    let remainingNumbers = fullNumber[1].replace(/ |-|_/g, '');

                    formattedValue = dialCode+'/'+prefixCode+'/'+remainingNumbers;
                }

                hiddenInput[0].value = formattedValue;
            }
        });

        const iti = intlTelInput(input, {
            separateDialCode: true,
            strictMode: true,
            formatOnDisplay: true,
            nationalMode: false,
            validationNumberType: 'MOBILE',
            initialCountry: 'ch',
            onlyCountries: ['ch'],
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.3.2/build/js/utils.js",
            hiddenInput: function(telInputName) {
                return {
                    phone: input.id
                }
            }
        });
    }
}
